// extracted by mini-css-extract-plugin
export default {"wrapper":"okFyzC7BkhUXrL11D76H","input":"KDGMouDz4_cARQu5EjAJ","switchWrapper":"vK6FYcJDfMu9U_7NfPxr","isAddNewRow":"anXDyRfZ_kgYAGeohZti"};